<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { partyBuildingImgPath, imgPath } from '@/utils/filters.js'

export default {
  name: 'Comp2',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    },
    getImgURL({ photo, typeid }) {
      const firstImg = photo.split(',')[0]
      return typeid === 0
        ? partyBuildingImgPath(firstImg)
        : imgPath(photo)
    }
  }
}
</script>

<template>
  <div class="modules-id-2">
    <module-title :title="moduleOption.title" margin-bottom="28" />
    <div class="comp-transverse-3 modules-id-2-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 2)"
        :key="`modules-2-${v.id}`"
        class="item"
        :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
        @click="onModuleItem(v)"
      >
        <!-- v.typeid=== 0: partyBuildingImgPath  -->
        <el-image class="images" :src="getImgURL(v)" alt="images" fit="cover" />
        <div class="mid-style">
          <img class="lines-img" :class="{'hidden': i === 1}" :src="require('imgs/modules/lines.png')" alt="lines">
          <span class="retanc"></span>
          <img class="lines-img" :class="{'hidden': i === 0}" :src="require('imgs/modules/lines.png')" alt="lines">
        </div>
        <p class="title">{{ v.headline | textLenHandler(20) }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-2-content {
  display: flex;
  justify-content: space-between;
  // display: grid;
  // grid-template-columns: repeat(auto-fill, 151px);
  .item {
    width: 220px;
    height: 322px;
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images {
    width: 201px;
    height: 168px;
    border-radius: 5px;
  }
  .title {
    width: 172px;
    font-size: 15px;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-top: 30px;
  }
}
.mid-style {
  width: 206px;
  height: 24px;
  display: flex;
  justify-content: space-between;
  margin-top: 17px;
  .lines-img {
    width: 63px;
    height: 18px;
  }
  .hidden {
    visibility: hidden;
  }
  .retanc {
    width: 15px;
    height: 4px;
    background: #DD4135;
    margin-top: 20px;
    border-radius: 3px;
  }
}
</style>
